import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3338136e")
const _hoisted_1 = { class: "p-d-flex p-ai-center p-jc-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-receipt" }),
  /*#__PURE__*/_createTextVNode(" Riepilogo ")
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "p-text-normal p-text-right" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Codice ordine", -1)
const _hoisted_7 = { class: "p-grid" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-12 p-sm-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Creato in data:")
], -1)
const _hoisted_9 = { class: "p-col p-text-uppercase" }
const _hoisted_10 = { class: "p-grid" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-12 p-sm-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Giorno e ora di esecuzione:")
], -1)
const _hoisted_12 = { class: "p-col" }
const _hoisted_13 = {
  key: 0,
  class: "p-text-uppercase"
}
const _hoisted_14 = {
  key: 1,
  class: "date-edit-section"
}
const _hoisted_15 = { class: "p-text-uppercase p-mb-2" }
const _hoisted_16 = { class: "p-grid p-ai-center" }
const _hoisted_17 = {
  class: "p-col-fixed",
  style: {"width":"5.5rem"}
}
const _hoisted_18 = { class: "p-grid" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "p-col-fixed",
  style: {"width":"6rem"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Ritiro: ")
], -1)
const _hoisted_20 = {
  key: 0,
  class: "p-col"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", null, "entro la fascia oraria selezionata", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "p-col"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle text-danger" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("strong", null, "Urgente", -1)
const _hoisted_26 = { class: "p-grid" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", {
  class: "p-col-fixed",
  style: {"width":"6rem"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Consegna: ")
], -1)
const _hoisted_28 = {
  key: 0,
  class: "p-col"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", null, "entro la fascia oraria selezionata", -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "p-col"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle text-danger" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("strong", null, "Urgente", -1)
const _hoisted_34 = {
  key: 2,
  class: "p-grid"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", {
  class: "p-col-fixed",
  style: {"width":"6rem"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Preavviso:")
], -1)
const _hoisted_36 = { class: "p-col" }
const _hoisted_37 = { class: "p-grid" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-12 p-sm-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Tipologia richiesta:")
], -1)
const _hoisted_39 = { class: "p-col" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "p-ml-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Colli:")
], -1)
const _hoisted_41 = { class: "p-ml-2" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_43 = { class: "p-grid" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h5", { class: "p-col-12 p-sm-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Contatti d'emergenza ordine")
], -1)
const _hoisted_45 = { class: "p-col-12" }
const _hoisted_46 = { class: "p-grid" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-12 p-sm-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome Mittente:")
], -1)
const _hoisted_48 = { class: "p-col p-text-uppercase" }
const _hoisted_49 = { class: "p-grid" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-12 p-sm-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Telefono Mittente:")
], -1)
const _hoisted_51 = { class: "p-col p-text-uppercase" }
const _hoisted_52 = ["href"]
const _hoisted_53 = { class: "p-grid p-ai-center" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-12 p-sm-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Assegnato a:")
], -1)
const _hoisted_55 = {
  key: 0,
  class: "p-col"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("strong", null, "Fornitore:", -1)
const _hoisted_57 = {
  key: 1,
  class: "p-col"
}
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Ordine interno in attesa di assegnazione ad un Taker")
const _hoisted_59 = /*#__PURE__*/_createElementVNode("strong", null, "Taker:", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_ShiftToText = _resolveComponent("ShiftToText")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    id: "order_data",
    class: "p-my-2"
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.isCustomer || _ctx.isTMT || (_ctx.isSupplier && _ctx.order.external_client_code))
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createElementVNode("small", _hoisted_4, [
                (_ctx.isSupplier || _ctx.readonly)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("div", null, _toDisplayString(_ctx.clientCode), 1)
                    ]))
                  : (_openBlock(), _createBlock(_component_FloatLabel, {
                      key: 1,
                      label: "Codice ordine"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.clientCode,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.clientCode = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.creationDateTime), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", _hoisted_12, [
          (_ctx.readonly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.executionDatetime), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.executionDatetime), 1),
                _createVNode(_component_FloatLabel, { label: "Modifica data" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Calendar, {
                      modelValue: _ctx.pickupDate,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pickupDate = $event)),
                      showIcon: true,
                      showButtonBar: true,
                      dateFormat: "dd/mm/yy",
                      placeholder: "Seleziona data"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, [
              _createElementVNode("b", null, "Fascia: " + _toDisplayString(_ctx.order.shift.name), 1)
            ]),
            _createVNode(_component_ShiftToText, {
              class: "p-col",
              shift: _ctx.order?.shift
            }, null, 8, ["shift"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            (!_ctx.pickup_priority)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _hoisted_22))
              : (_openBlock(), _createElementBlock("span", _hoisted_23, [
                  _hoisted_24,
                  _createTextVNode(" " + _toDisplayString(_ctx.pickupTime) + " ", 1),
                  _hoisted_25
                ]))
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            (!_ctx.dropoff_priority)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _hoisted_30))
              : (_openBlock(), _createElementBlock("span", _hoisted_31, [
                  _hoisted_32,
                  _createTextVNode(" " + _toDisplayString(_ctx.dropoffTime) + " ", 1),
                  _hoisted_33
                ]))
          ]),
          (_ctx.showWarningTime)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.warningTime), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _hoisted_38,
        _createElementVNode("span", _hoisted_39, [
          _createElementVNode("i", {
            class: _normalizeClass(`fas fa-${_ctx.order.vehicle.icon}`)
          }, null, 2),
          _createTextVNode(" " + _toDisplayString(_ctx.order.vehicle?.name_it) + " ", 1),
          (_ctx.order.vehicle?.is_package)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_40,
                _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.order.items_qty), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.order.ref_sender_name || _ctx.order.ref_sender_phone)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("span", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.order.ref_sender_name), 1)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("span", _hoisted_51, [
                    _createElementVNode("a", {
                      href: `tel:${_ctx.order.ref_sender_phone}`
                    }, _toDisplayString(_ctx.order.ref_sender_phone), 9, _hoisted_52)
                  ])
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_53, [
        ((_ctx.isTMT || _ctx.isCustomer) && _ctx.order.entity_id)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_54,
              (_ctx.order.entity_type === _ctx.supplierValue)
                ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                    _hoisted_56,
                    _createTextVNode(" " + _toDisplayString(_ctx.order.entity?.name), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.entity_type === _ctx.takerValue)
                ? (_openBlock(), _createElementBlock("span", _hoisted_57, [
                    (!_ctx.order.entity_id)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_58
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_59,
                          _createTextVNode(" " + _toDisplayString(_ctx.order.entity?.name), 1)
                        ], 64))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}